/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail/AddEmail/Content/SaveAction",
  onSubmit,
  isSubmitting
  
}) {
let selectedSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
let selectedIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 data="selected"
 onClick={selectedSubmitData}
 disabled={selectedIsSubmittingData}
 text="Save"
/>
{children}
</React.Fragment>)
}